import app from 'flarum/forum/app';
import updateHeader from './updateHeader';
app.initializers.add('dvdfab/header', () => {
  const language =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;

  // 智能语言匹配函数
  const getLanguage = (browserLang: string): string => {
    if (!browserLang) return 'en';

    const lang = browserLang.toLowerCase();

    // 英语匹配：en 或 en- 开头
    if (lang === 'en' || lang.startsWith('en-')) {
      return 'en';
    }

    // 中文匹配：zh 或 zh- 开头
    if (lang === 'zh' || lang.startsWith('zh-')) {
      return 'zh-Hant';
    }

    // 法语匹配：fr 或 fr- 开头
    if (lang === 'fr' || lang.startsWith('fr-')) {
      return 'fr';
    }

    // 日语匹配：ja 或 ja- 开头
    if (lang === 'ja' || lang.startsWith('ja-')) {
      return 'ja';
    }

    // 德语匹配：de 或 de- 开头
    if (lang === 'de' || lang.startsWith('de-')) {
      return 'de';
    }

    // 默认返回英语
    return 'en';
  };

  // 获取cookie中的locale值
  const getCookieLocale = (): string | null => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'locale') {
        return value;
      }
    }
    return null;
  };

  // const lang = getLanguage(language);
  // const cookieLocale = getCookieLocale();
  
  // 如果app.data.locale存在或cookie中已有locale，则不执行任何操作
  // console.log('app.data.locale', app.data.locale);
  // console.log('cookieLocale', cookieLocale);
  
  //  if (app.session.user) {
  //   app.session.user.savePreferences({ locale: lang }).then(() => window.location.reload());
  // } else {
  //   document.cookie = `locale=${lang}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
  //   window.location.reload();
  // }
  updateHeader();
});
